<template>
  <div class="shadow-setting setting-popup" v-if="boxData.judgeBox" :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex}" @mousedown.stop.prevent>
    <div
      class="setting-popup__drag-area"
      @mousedown="moveStart($event, true)"
      @mousemove="moveArea($event)"
      @mouseup="saveMoveState($event)" :style="{'cursor': 'move'}"
    >
      阴影
    </div>
    <div class="setting-popup__content">
      <div class="shadow-type radios" v-show="sprite.type!=='Text'">
        <div class="radios__title"> 阴影类型</div>
        <ul class="radios__list">
          <li class="radios__item" 
          :class="{active: item.active}" 
          v-for="(item, key) in typeList" 
          :key="key"
          @click="selectType(item, key)">
            <i></i>
            <span>{{item.text}}</span>
          </li>
        </ul>
        <el-tooltip effect="dark" content="素材抠图后，设置元素阴影效果更佳" placement="top" :open-delay="500">
          <div class="shadow-help">?</div>
        </el-tooltip>
      </div>
      <div class="shadow-color">
        <div>颜色</div>
        <div class="color" @click="showColorPicker();$analysis(ANALYSIS.color)" :style="{background: shadow.color}"></div>
      </div>
      <div class="shadow-item" v-dragWhole>
        <div class="slider" 
          v-for="(item, key) in attr" 
          :key="key"
          v-show="item.name !== 'spread'||type!=='dropShadow'">
          <div class="slider-before">{{item.text}}</div>
          <div class="rc-slider">
            <div class="rc-slider-rail"></div>
            <div class="rc-slider-track" :style="{'width': (shadow[item.name] - item.min)/item.len*100 + '%'}"></div>
            <div :data-action="item.name+'-'+key" class="rc-slider-handle" :style="{'left': (shadow[item.name] - item.min)/item.len*100 + '%'}"></div>
          </div>
          <div class="slider-after">
            <input type="number"
            @focus="inputFocus(item)"
            v-model="shadow[item.name]"
            @keydown.stop
            @mousedown.stop
            @click.stop
            >
          </div>
        </div>
      </div>
      <div class="reset">
        <el-button class="reset-button" plain @click="setShadow(true);$analysis(ANALYSIS.reset)">重置</el-button>
      </div>
    </div>
     <div class="setting-popup__close" @click="close"><i class="icon-popup-close"></i></div>
     <div class="setting-popup__mask" v-show="isShowMask" @click="closeNextPopup('color')"></div>
  </div>
</template>

<script>
import popup from '../../mixins/popup.vue'

export default{
  mixins: [popup],
  data() {
    return {
      ANALYSIS: {
        boxShadow : {category:'shadow_setting_panel', action:'click_shadow_bordertype', label:'阴影设置面板_点击_阴影_边框'},
        dropShadow : {category:'shadow_setting_panel', action:'click_shadow_elementtype', label:'阴影设置面板_点击_阴影_元素类型'},
        color : {category:'shadow_setting_panel', action:'click_shadow_color', label:'阴影设置面板_点击_阴影_颜色'},
        x : {category:'shadow_setting_panel', action:'drag_shadow_xoffset', label:'阴影设置面板_点击_阴影_x偏移'},
        y : {category:'shadow_setting_panel', action:'drag_shadow_yoffset', label:'阴影设置面板_点击_阴影_y偏移'},
        blur : {category:'shadow_setting_panel', action:'drag_shadow_blur', label:'阴影设置面板_点击_阴影_模糊'},
        spread : {category:'shadow_setting_panel', action:'drag_shadow_spread', label:'阴影设置面板_点击_阴影_扩散'},
        reset : {category:'shadow_setting_panel', action:'click_shadow_reset', label:'阴影设置面板_点击_阴影_重置'}
      },
      popupType: 'shadowSetting',
      type: 'boxShadow', // 两种类别
      shadow: {
        x: 0,
        y: 0,
        blur: 0,
        spread: 0,
        color: '#ffffff'
      },
      typeList: [ // 类别选择数组
        {type: 'boxShadow', text: '边框', active: true},
        {type: 'dropShadow', text: '元素', active: false}
      ],
      attr: [ // 拖动属性数组
        {name: 'x', text: 'X偏移', step: 1, min: -100, max: 100, len: 200},
        {name: 'y', text: 'Y偏移', step: 1, min: -100, max: 100, len: 200},
        {name: 'blur', text: '模糊', step: 1, min: 0, max: 50, len: 50},
        {name: 'spread', text: '扩散', step: 1, min: -100, max: 100, len: 200}
      ],
      item: null, // 当前选择改变的属性对象
      action: '', // 拖动动作
      mpos: null,
      dragHand: false
    }
  },
  watch: {
    'boxData.judgeBox'(val, oldVal){
      if(val) {
        this.initData()
      } else {
        this.closeNextPopup('color');
      }
    },
    shadow: {
      handler (val, oldVal) {
        if(this.item && typeof val[this.item.name]==='string') {
          this.calcData()
        }
      },
      deep: true
    }
  },
  mounted() {
    this.$bus.on('colorPickerInput.shadowSetting', this.colorPicker);
    this.$bus.on('undoRedoHandle', (data) => {
      // 撤销和恢复的事件
      if (this.boxData.judgeBox && data.type === 'setShadow') this.initData();
    })
  },
  methods: {
    initData() {
      if(this.sprite.type === 'Text') {
        this.selectType(this.typeList[1], 1);
      }
      let shadow = this.sprite[this.type];
      if(!shadow)
        shadow = {
          x: 0,
          y: 0,
          blur: 0,
          spread: 0,
          color: '#ffffff'
        }
      Object.assign(this.shadow, shadow)
    },
    selectType(item, key) {
      if(item.active) return;
      this.typeList.forEach((val, k) => {
        val.active = false;
        k === key && (val.active = true);
      })
      this.type = item.type;
      this.initData();
      this.$analysis(this.ANALYSIS[item.type]);
    },
    showColorPicker(whichPart) {
      this.$bus.emit('FeaturesPop_vue', {
        name: 'color',
        type: 1,
        source: this,
        color: this.shadow.color
      })
      this.toggleMask(true);
    },
    colorPicker(obj) {
      if(obj.hex) {
        this.shadow.color = obj.hex;
        this.setShadow();
      }
    },
    inputFocus(item) {
      this.item = item;
    },
    inputChange(e, item) {
      this.calcData();
    },
    calcData() {
      // 数据取整，和限定范围
      if(this.dragHand || !this.item) return;
      let item = this.item,
          val = Math.round(this.shadow[item.name]);
      if(val > item.max) {
        this.shadow[item.name] = item.max;
      } else if (val < item.min) {
        this.shadow[item.name] = item.min;
      } else {
        this.shadow[item.name] = val;
      }
      this.setShadow();
    },
    dragDown(dis, action) {
      if(!action) return;
      let actionS = action.split('-');
      this.action = actionS[0];
      this.item = this.attr[+actionS[1]];
      this.dragHand = true;
      this.mpos = {
        x: dis.x,
        v: this.shadow[this.action]
      }
    },
    dragMove(pos, action) {
      if(!this.action) return;
      let pre = Math.round((pos.x - this.mpos.x) / 105 * this.item.len + this.mpos.v);
      this.shadow[this.action] = pre > this.item.max ? this.item.max : pre < this.item.min ? this.item.min : pre;
    },
    dragUp(pos, action) {
      if(!this.action) return;
      this.setShadow();
      this.mpos = null;
      this.dragHand = false;
      this.$analysis(this.ANALYSIS[this.action]);
      this.action = '';
    },
    setShadow(reset) {
      let shadow = Object.assign({}, this.shadow);
      if(reset) {
        shadow = null;
        this.shadow = {
          x: 0,
          y: 0,
          blur: 0,
          spread: 0,
          color: '#ffffff'
        }
      }
      let undoData = {
        spriteId: this.sprite.id,
        scenesId: this.sprite.scenesId,
        reData: {
          type: this.type,
          data: Object.assign({},this.sprite[this.type])
        },
        data: {
          type: this.type,
          data: shadow
        }
      }
      this.sprite.setShadow(shadow, this.type);
      eve("undo_redo", null, { type: 'setShadow', data: undoData})
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 258px;
  min-height: 180px;
  z-index: 35;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  font-size: 14px;
  box-shadow: 0 0 3px 1px #d8dee9;
  color: #474261;

  &__drag-area {
    line-height: 28px;
    background: #d8dee9;
    text-align: left;
    text-indent: 14px;
    cursor: move;
  }

  &__close {
    position: absolute;
    top: 7px;
    right: 12px;
    height: 14px;
    line-height: 14px;
    width: 14px;
    cursor: pointer;
  }

  &__content {
    padding: 14px 18px;
  }

  &__mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(#ffffff, 0.7);
  }
}

.radios {
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;

  &__title {
    width: 70px;
    font-size: 14px;
    text-align-last: left;
  }

  &__list {
    display: flex;
    width: 125px;
    justify-content: space-between;
    align-items: center;
  }
  &__item {
    display: flex;
    align-items: center;
    font-size: 14px;
    cursor: pointer;

    &>i {
      width: 16px;
      height: 16px;
      border-radius: 16px;
      border: solid 1px #474260;
    }
    &>span {
      padding-left: 5px;
    }

    &.active>i {
      background-color: #5778F9;
      border-color: #5778F9;
      box-shadow: 0 0 0 3px #ffffff inset;
    }
  }
}

.shadow-help {
  margin-left: 5px;
  width: 16px;
  height: 16px;
  line-height: 16px;
  color: #fff;
  background-color: #474261;
  border-radius: 50%;
  cursor: pointer;
}

.shadow-color {
  display: flex;
  align-items: center;

  div {
    width: 60px;
    text-align: left;
  }

  .color {
    width: 58px;
    height: 26px;
    border-radius: 4px;
    background-color: #5779fa;
    cursor: pointer;
    box-shadow: 0 0 3px 0px rgba(0,0,0,0.5);
  }
}

.slider {
  width: 100%;
  display: flex;
  margin: 19px auto;
  justify-content: space-between;
  align-items: center;
  
  .slider-before {
    width: 40px;
    text-align: left;
  }
  .slider-after {
    width: 52px;

    input {
      width: 100%;
      height: 30px;
      border: 1px solid #d9dde9;
      border-radius: 4px;
      text-align: center;
    }
  }
}
.rc-slider {
  position: relative;
  height: 15px;
  padding: 5px 0;
  width: 105px;
  -ms-touch-action: none;
  touch-action: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .rc-slider-rail {
    position: absolute;
    width: 100%;
    background-color: #e6e6f4;
    height: 4px;
    border-radius: 3px;
  }

  .rc-slider-track {
    position: absolute;
    background-color: #5779FA;
    border-radius: 3px;
    height: 4px;
    left: 0%;
    width: 69.1515%;
  }

  .rc-slider-handle {
    position: absolute;
    margin-left: -7px;
    margin-top: -5px;
    left: 69.1515%;
    width: 14px;
    height: 14px;
    background-color: #ffffff;
    border: 1px solid #5779FA;
    cursor: -webkit-grab;
    cursor: grab;
    border-radius: 50%;
    -ms-touch-action: pan-x;
    touch-action: pan-x;
  }
}
.reset {
  width: 100%;
  border-top: 1px solid #F4F3F8;
  margin: -3px 0 5px;
  
  .reset-button {
    width: 100px;
    height: 33px;
    line-height: 0px;
    background-color: #F5F4F9;
    margin-top: 18px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/popupsNew/shadowSetting/shadowSetting.vue